module.exports = __webpack_public_path__ + "img/margot-hohl.0f1484db.jpg";